import React, { FC } from 'react';

interface AccordionProps {
  stepNumber: number;
  kicker: string;
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

const Accordion: FC<AccordionProps> = ({
  stepNumber,
  kicker,
  title,
  isOpen,
  onToggle,
  children,
}) => (
  <div className="border-b border-slate-200 last:border-b-0 md:border-b-0">
    <button
      type="button"
      onClick={onToggle}
      className="md:hidden w-full flex items-center gap-3 p-4 text-left min-h-yn-btn"
      aria-expanded={isOpen}
    >
      <span
        className={`
          w-6 h-6 rounded-full flex items-center justify-center
          text-xs font-bold flex-shrink-0
          ${isOpen ? 'bg-brand text-white' : 'bg-slate-200 text-slate-600'}
        `}
      >
        {stepNumber}
      </span>
      <span className="flex-1 min-w-0">
        <span className="block text-xs text-slate-400 uppercase tracking-wide">
          {kicker}
        </span>
        <span className="block text-sm font-bold text-slate-800">
          {title}
        </span>
      </span>
      <span
        className={`text-slate-400 text-lg transition-transform flex-shrink-0 ${
          isOpen ? 'rotate-180' : ''
        }`}
        aria-hidden
      >
        ⌄
      </span>
    </button>
    <div className={`${isOpen ? 'block' : 'hidden'} md:block px-4 pb-4 md:px-0 md:pb-0`}>
      {children}
    </div>
  </div>
);

export default Accordion;
